
import React, { useEffect, useState } from 'react';
import { LOGO_IMG } from '../../../../utills/image-constant';
import { checkValidation, ErrorMessage, ErrorMsg } from '../../../../utills/error-message-constant';
import { emailRegex } from '../../../../utills/form-regex';
import { useNavigate } from 'react-router-dom';
import Inputwithlable from '../../../../admin/components/common/inputwithlable';
import Loginbtn from '../../../../admin/components/common/loginbtn';
import { userLogin } from '../../../../services/api-services';
import { toastEmitter } from '../../../../utills/utilities';
import { API_RESPONSE } from '../../../../utills/app-constant';
import { USERROUTES } from '../../../routes/url-constant';


const UserLogin = () => {
    const [email, setEmail] = useState();
    const [formError, setFormError] = useState();
    const [forgetbtnLoader, setForgetbtnLoader] = useState(false)
    const [forgetbtndisable, setForgetbtndisable] = useState(true)
    const navigation = useNavigate();

    const handleUserLoginChange = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.Email,
                emailRegex,
                formError,
                setFormError
            );
        }
        setEmail(value)
    }

    useEffect(() => {
        if (!email || formError?.email) {
            setForgetbtndisable(true);
        } else {
            setForgetbtndisable(false);
        }
    }, [formError, email]);

    const handleUserLogin = async () => {
        setForgetbtndisable(true);
        setForgetbtnLoader(true)
        try {
            const response = await userLogin(email);
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
                setForgetbtnLoader(false)
                setForgetbtndisable(false);
            }
            if (response.data?.responseCode === 200) {
                toastEmitter("success", response?.data?.message);

                setForgetbtnLoader(false)
                setForgetbtndisable(true);
                navigation(USERROUTES.USEROTP, {
                    state: { email: email },
                })

                setEmail("")
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
            setForgetbtnLoader(false)
            setForgetbtndisable(false);
        }
    }


    return (
        <>
            <div className="caspera_login_account_content d-flex justify-content-center align-items-center">
                <div class="card forget-div rounded-4 shadow-sm p-5 pt-4 pb-4 border-0">
                    <div class="card-body">
                        <div className='d-flex justify-content-center align-items-center'>
                            <img src={LOGO_IMG} class="img-fluid mb-4 logo_img" alt="..." />
                        </div>
                        <p className='card-text text-center mb-1 textfont12'>WELCOME BACK</p>
                        <h5 class="card-text text-center">Log In to Your Account</h5>
                        <div class="">
                            <Inputwithlable
                                type="email"
                                name="email"
                                labelName="Email"
                                lableclassName='input-label'
                                className="form-control inputText-lable"
                                placeholder="Enter Email"
                                handleChange={handleUserLoginChange}
                                value={email}
                                error={formError?.emailStatus}
                            />
                        </div>
                        <div className="mt-2 ms-2"><ErrorMsg error={formError?.email} /></div>
                        <Loginbtn
                            className="submitbtn textfont12 mt-3"
                            handleClick={handleUserLogin}
                            type="submit"
                            btnName="GET OTP"
                            loader={forgetbtnLoader}
                            disablebtn={forgetbtndisable}
                        />

                    </div>
                </div>


            </div>

        </>
    )
}

export default UserLogin
